// タイトルの右端に「数値の月」を“追加”する（置き換えない）
function ensureNumericMonthBadge(rootEl){
  // 一呼吸おいて、FCの内部描画完了後に実行
  requestAnimationFrame(() => {
    rootEl.querySelectorAll('.fc-multimonth-month').forEach(monthEl => {
      const titleEl = monthEl.querySelector('.fc-multimonth-title');
      if(!titleEl) return;

      // すでに数字が付いていれば何もしない（重複防止）
      if (titleEl.querySelector('.fc-mm-num')) return;

      // 月番号は data-date（その月の1日）から取るのが最も確実
      const dataDate = monthEl.getAttribute('data-date') || titleEl.getAttribute('data-date');
      let monthNumber = '';
      if (dataDate){
        const d = new Date(dataDate);
        if(!isNaN(d)) monthNumber = d.getMonth() + 1; // 1..12
      } else {
        // 最終手段：タイトルテキストから英語月名をパース
        const txt = titleEl.textContent.trim();
        // 例: "July 2025" → 月名をDateで解釈
        const trial = new Date(txt);
        if (!isNaN(trial)) monthNumber = trial.getMonth() + 1;
      }

      const badge = document.createElement('span');
      badge.className = 'fc-mm-num';
      badge.setAttribute('aria-hidden', 'true');
      badge.textContent = monthNumber || '';
      titleEl.appendChild(badge);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('g_calendar');

  const calendar = new FullCalendar.Calendar(el, {
    locale: 'en',                           // 英語表記（July 2023）
    timeZone: 'Asia/Tokyo',
    initialView: 'multiMonthTwoMonth',
    views: { multiMonthTwoMonth: { type:'multiMonth', duration:{ months:2 } } },
    multiMonthTitleFormat: { month: 'long', year: 'numeric' }, // 常に "July 2025" の形
    headerToolbar: false,
    height: 'auto',
    expandRows: true,
    
    // ▼ Googleカレンダーを出すなら有効化（公開カレンダー必須）
    googleCalendarApiKey: 'AIzaSyCNM0LHvRcaCd5zAEtkmu2BCPrBM2j_9vw',
    events: { googleCalendarId: 'tuuliofficial.jp@gmail.com' },

    // レンダリングのたびに数字バッジを“追加”する
    viewDidMount(){ ensureNumericMonthBadge(el); },
    datesSet(){ ensureNumericMonthBadge(el); }
  });

  calendar.render();
  ensureNumericMonthBadge(el); // 初回
});